import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class RefreshService {
  private _refresh$ = new Subject<void>();

  get refresh$() {
    return this._refresh$.asObservable();
  }

  refresh() {
    this._refresh$.next();
  }
}
